export default __webpack_public_path__ + "static/media/apt.0f2fb875.jpg";